'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import VisitesContent from './components/VisitesContent';

export default function VisitesPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur', 'Broker']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/visites">
        <VisitesContent />
      </AppLayout>
    </RouteGuard>
  );
}
